import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import AppManager from "../../managers/AppManager";
import RouteManager from "../../managers/RouteManager";
import PerformaceService from "../../services/PerformaceService";
import {
    DKLabel,
    DKButton,
    DKInput,
    DKIcon,
    INPUT_TYPE,
    INPUT_VIEW_DIRECTION,
    DKLine,
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
    showAlert
} from "deskera-ui-library";
import moment from "moment";
import { COMPANY_DATE_FORMATS, DATE_FORMAT } from "../../constants/Constant";
import ProgressBar from "@ramonak/react-progress-bar";
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import ic_no_data from "../../assets/icons/ic_no_data_3.png";
import { renderGoal } from "./PerformanceConstant";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import MessageInfo from "../common/MessageInfo";



function SelfAssessment(props) {
    const history = useHistory();
    const { t } = useTranslation();

    const [count, updateCount] = useState(1);
    const [ratings, setRatings] = useState([]);
    const [activeCycle, setActiveCycle] = useState(-1);
    const [selfAssessments, setSelfAssessments] = useState([]);
    const [assessmentSubmitted, setAssessmentSubmitted] = useState(true);
    const [assessmentPeriod, setAssessmentPeriod] = useState(null);
    const [assessmentPeriodOptions, setAssessmentPeriodOptions] = useState([]);
    const [questionsCount, setQuestionsCount] = useState(0);
    const [selfAssessmentPercent, setSelfAssessmentPercent] = useState(0);
    const [updateSelfAssessmentPercent, setUpdateSelfAssessmentPercent] = useState(false);
    const [goals, setGoals] = useState([]);
    const [goalSubmissions, setGoalSubmissions] = useState([]);
    const [hasEnableAsessment, setEnableAssessments] = useState(true);

    let dateFormat = COMPANY_DATE_FORMATS.filter(c => c.label == TenantService.get(TENANT.DATE_FORMAT))[0]?.label
    

    const [goalAPIConfig,setAPIConfig] = useState({
        limit: 100,
        page: 0,
        search: '',
        sort: 'createdAt',
        sortDir: 'desc'
    })
    
    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();

        getRatings();
        getAppraisalSettings();
    }, []);

    useEffect(() => {
        if (activeCycle && isAllowSelfAssessment(activeCycle)) {
            getSelfAssessment();
        }
    }, [activeCycle]);

    useEffect(() => {
        if (selfAssessments?.length > 0 && updateSelfAssessmentPercent) {
            calcuateSelfAssessmentPercent();
            setUpdateSelfAssessmentPercent(false);
        }
    }, [selfAssessments]);

    const forceUpdate = () => {
        updateCount(count + 1);
    }

    const buildAssessmentPeriodOptions = (assessmentPeriod) => {
        const options = [
            {
                value: assessmentPeriod.id,
                label: `${moment(assessmentPeriod.startDate, DATE_FORMAT.IND).format("DD MMMM YYYY")} - ${moment(assessmentPeriod.endDate, DATE_FORMAT.IND).format("DD MMMM YYYY")}`
            }
        ];

        setAssessmentPeriodOptions(options);

        if (options.length > 0) {
            setAssessmentPeriod(options[0].label);
        }
    }

    const isAllowSelfAssessment = (activeCycle) => {
        if (activeCycle.dueDate) {
            const startDate = moment(activeCycle.dueDate, DATE_FORMAT.IND).subtract(30, "days").startOf("day");
            const endDate = moment(activeCycle.dueDate, DATE_FORMAT.IND).endOf("day");
            return moment().isBetween(startDate, endDate);
        }

        return false;
    }

    const hasSelfAssessmentPeriod = (activeCycle) => {
        if (activeCycle.hasSelfAssessmentPeriod) {
            const startDate = moment(activeCycle.selfAssessmentStartDate, DATE_FORMAT.IND).startOf("day");
            const endDate = moment(activeCycle.selfAssessmentDueDate, DATE_FORMAT.IND).endOf("day");
            const isBetween = moment().isBetween(startDate, endDate)
            return isBetween;
        }
        return true;
    }

    const getRatings = () => {
        PerformaceService.getRatings().then(
            (response) => {
                if (response?.length > 0) {
                    setRatings(response);
                }
            }, (error) => {
                setRatings([]);
            }
        );
    }

    const getAppraisalSettings = () => {
        PerformaceService.getAppraisalSettings().then(
            (response) => {
                if(!Utility.isEmpty(response)) {
                    const iamUserId = TenantService.get(TENANT.IAM_USER_ID);
                    let activeAppraisal;
                    if(response?.find) {
                        activeAppraisal = response.find(res=>res?.applicability?.users?.some(id=>id===parseInt(iamUserId)) && res?.active);
                    } else if(typeof response === 'object') {
                        activeAppraisal = response
                    }
                    if (activeAppraisal?.questions?.length > 0 && isAllowSelfAssessment(activeAppraisal)) {
                        setActiveCycle(activeAppraisal);
                        buildAssessmentPeriodOptions(activeAppraisal);
                        setEnableAssessments(hasSelfAssessmentPeriod(activeAppraisal)? true:false)
                    } else {
                        setActiveCycle(null);
                    }
                }
            }, (error) => {
                setActiveCycle(null);
            }
        );
    }

    const calcuateSelfAssessmentPercent = () => {
        let total = 0;
        selfAssessments.forEach((assessment) => {
            if (!Utility.isEmpty(assessment.value) && !Utility.isEmpty(assessment.rating)) {
                total += 1;
            }
        });

        const assessmentPercent = (total / selfAssessments.length) * 100;
        setSelfAssessmentPercent(!isNaN(assessmentPercent) ? Math.floor(assessmentPercent) : 0);
    }

    const getAssessmentComment = (assessment, questionId) => {
        if (assessment?.length > 0) {
            const comment = assessment.find((assessment) => assessment.questionId === questionId);
            return {
                comment: comment.comment,
                rating: comment.rating
            };
        }

        return {};
    }

    const getAssessmentField = (questionId, comment) => {
        return {
            id: questionId,
            title: "",
            placeholder: t("COMMENT_PLACEHOLDER"),
            type: INPUT_TYPE.LONG_TEXT,
            showValueLength: true,
            validation: [["required"], ["maxLength", 500]],
            value: comment
        }
    }

    const setAssessments = (response, setState) => {
        const assessments = [];
        const sortedQuestions = response.questions.sort((q1, q2) => q1.seq - q2.seq);
        sortedQuestions.forEach((question) => {
            const assessment = {
                seq: question.seq,
                questionId: question.id,
                question: question.question,
                ...getAssessmentComment(response.assessments, question.id)
            };

            assessments.push({
                ...assessment,
                ...getAssessmentField(assessment.questionId, assessment.comment)
            });
        });

        setState(assessments);
    }

    const getSelfAssessment = () => {
        const params = {
            appraisalId: activeCycle.id
        }

        showLoader();
        PerformaceService.getSelfAssessment(params).then(
            (response) => {
                removeLoader();
                if (response?.questions?.length > 0) {
                    setUpdateSelfAssessmentPercent(true);
                    setAssessments(response, setSelfAssessments);
                    setQuestionsCount(response.questions.length);
                    setAssessmentSubmitted(response.assessmentSubmitted);
                }
                if(response?.goals) {
                    let goals = response?.goals || [];

                    
                    if(Utility.isEmpty(response.goalSubmissions)) {
                        PerformaceService.getGoals(goalAPIConfig).then(res => {
                            if (res && res.content) {
                                setGoalSubmissions(
                                    res.content?.map(g=>{
                                        return {
                                            "goalId": g.id,
                                            "progress": g.progress || 0,
                                            "comments": []
                                        }
                                    })
                                )
                                setGoals(res.content)
                            }
                        }, error => {
                            console.log(error);
                        })
                        
                    } else {
                        setGoalSubmissions(response.goalSubmissions)
                    }
                    
                }
            }, (error) => {
                if(error.errorMessage) {
                    showAlert('Appraisal is not assigned yet', error.errorMessage)   
                }
                setActiveCycle(null);
                removeLoader();
            }
        );
    }

    const isInvalid = () => {
        let invalid = false;

        if (Array.isArray(selfAssessments)) {
            const newState = [...selfAssessments].map((question) => {
                const newQuestion = {...question, ...hasError(question, question.value)};
                if (newQuestion.invalid) {
                    invalid = true;
                }

                if (Utility.isEmpty(newQuestion.rating)) {
                    invalid = true;
                    newQuestion.invalidRating = true;
                }

                return newQuestion;
            });

            setSelfAssessments(newState);
        }

        return invalid;
    }

    const getPayload = (isDraft) => {
        const assessments = selfAssessments.map((assessment) => {
            return {
                questionId: assessment.questionId,
                comment: assessment.value || "",
                rating: String(assessment.rating || "")
            }
        });

        const payload = {
            appraisalId: activeCycle.id,
            assessmentSubmitted: !isDraft,
            assessments: assessments,
            goalSubmissions: goalSubmissions
        }

        return payload;
    }

    const showConfirmationMessage = () => {
        if (isInvalid() || !hasEnableAsessment) {
            return;
        }

        showAlert(t("ALERT"), t("CONFIRMATION_MSG"), [
            {
                title: t("YES"),
                className: "bg-app text-white mr-xl",
                onClick: () => {
                    saveAssessmentReview(false);
                }
            },
            {
                title: t("NO"),
                className: "bg-gray1 border-m"
            }
        ]);
    }

    const saveAssessmentReview = (isDraft) => {
        if(!hasEnableAsessment) {
            return
        }
        showLoader(t("SAVING_APPRAISER_REVIEW"));
        const payload = getPayload(isDraft);
        PerformaceService.saveSelfAssessment(payload).then(
            (response) => {
                removeLoader();
                const msg = isDraft ? t("ASSESSMENT_DRAFT_SUCCESS") : t("ASSESSMENT_SAVE_SUCCESS");
                showToast(t(msg), TOAST_TYPE.SUCCESS);
                setAssessmentSubmitted(!isDraft);
            }, (error) => {
                removeLoader();
                showToast(error.errorMessage, TOAST_TYPE.FAILURE);
            }
        );
    }

    const isRequired = (validation) => {
        return validation ? validation.findIndex((v) => v[0] === "required") !== -1 : false;
    }

    const showError = (errorMessage) => {
        if (errorMessage) {
            return (
                <DKLabel
                    className="p-h-xl ml-xs fs-s text-red"
                    text={errorMessage}
                />
            )
        }
    }

    const getMaxLengthValue = (validation) => {
        return validation ? validation.find((v) => v[0] === "maxLength")?.[1] : false;
    }

    const showValueLength = (field) => {
        return (
            <DKLabel
                className="p-h-xl ml-auto"
                text={`${field.value?.length || 0}/${getMaxLengthValue(field.validation)}`}
            />
        );
    }

    const hasError = (field, value) => {
        let error = {
            invalid: false,
            errorMessage: null
        };

        const validation = field.validation;

        if (validation && validation.length !== 0) {
            validation.forEach((validation) => {
                switch (validation[0]) {
                    case "required":
                        if (value === null || value === undefined || String(value).trim() === "") {
                            error.invalid = true;
                        }
                        break;
                    case "maxLength":
                        if (value?.length > validation[1]) {
                            error.invalid = true;
                            error.errorMessage = t("MAXLENGTH_EXCEEDS");
                        }
                        break;
                    default:
                        error.invalid = false;
                        error.errorMessage = null;
                        break;
                }
            });
        }

        return error;
    }

    const updateState = (stateName, setState, state, value) => {
        let newState;

        switch (stateName) {
            case "selfAssessments":
                if (stateName === "selfAssessments") {
                    newState = [...selfAssessments];
                }

                if (Array.isArray(newState)) {
                    newState = newState.map((q) => {
                        if (q.id === state.id) {
                            q = {...q, ...value};

                            if (Object.keys(value)[0] === "rating") {
                                if (hasError(q, q.rating).invalid) {
                                    q.invalidRating = true;
                                } else {
                                    q.invalidRating = false;
                                }
                            } else {
                                q = {...q, ...hasError(q, q.value)};
                            }

                            if (!Utility.isEmpty(q.value) && !Utility.isEmpty(q.rating)) {
                                setUpdateSelfAssessmentPercent(true);
                            }
                        }

                        return q;
                    });
                }
                break;
            default:
                newState = {...state, ...value};
                newState = {...newState, ...hasError(newState, newState.value)};
                break;
        }

        setState(newState);
    }

    const renderField = (stateName, setState, field, width) => {
        switch (field.type) {
            case INPUT_TYPE.LONG_TEXT:
                return (
                    <div key={field.id} style={{ flex: "0 0 50%", maxWidth: width }}>
                        <div className="row pb-xl p-h-xl position-relative">
                            <DKInput
                                title={field.title}
                                type={field.type}
                                placeholder={field.placeholder}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                value={field.value}
                                errorMessage={field.errorMessage}
                                readOnly={!!field.readOnly || assessmentSubmitted || !hasEnableAsessment}
                                required={isRequired(field.validation)}
                                invalid={field.invalid}
                                canValidate={field.invalid}
                                onChange={(value) => {
                                    updateState(stateName, setState, field, {value: value});
                                }}
                            />
                        </div>
                        <div className="row" style={{ marginTop: "-20px", marginBottom: "9px" }}>
                            {field.invalid && showError(field.errorMessage)}
                            {field.showValueLength && showValueLength(field)}
                        </div>
                    </div>
                );
            default:
                break;
        }
    }

    const renderRatings = (assessment) => {
        const defaultCls = `column align-items-center p-xl bg-light-app-hover p-h-xxl rating ${assessmentSubmitted ? "rating-disabled" : "cursor-hand"}`;

        return (
            <div className="row p-h-xl m-v-xl">
                <div className={`d-flex ${assessment.invalidRating ? "rating-invalid" : "border-m"}`}>
                    {ratings.map((rating, index) => {
                        return (
                            <div
                                className={`${defaultCls} ${assessment.rating === rating.rating ? "rating-selected" : ""}`}
                                style={{
                                    borderRight: index !== ratings.length - 1 ? "1px solid #dcdcdc" : ""
                                }}
                                onClick={() => {
                                    if (!assessmentSubmitted && hasEnableAsessment) {
                                        updateState("selfAssessments", setSelfAssessments, assessment, { rating: rating.rating});
                                    }
                                }}
                            >
                                <DKLabel text={rating.rating} className="fw-b mb-s" />
                                <DKLabel text={rating.description} className="text-align-center" />
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    }

    const renderAssessmentQuestions = (assessment, index) => {
        return (
            <div>
                {index !== 0 && <DKLine className="bg-gray3 mb-xl" />}
                <DKLabel text={`${t("QUESTION")} ${index + 1}:`} className="text-uppercase text-gray p-h-xl" />
                <DKLabel text={assessment.question} className="fw-b fs-m mt-m p-h-xl" />
                <div className="mt-m">
                    {renderField("selfAssessments", setSelfAssessments, assessment, "90%")}
                </div>
                {renderRatings(assessment)}
            </div>
        );
    }
    
    
    

    const progressChange = (value,index) => {
        if(assessmentSubmitted) {
            return
        }
        let newGoalSubmission = deepClone(goalSubmissions)
        newGoalSubmission[index]['progress'] = value;
        setGoalSubmissions(newGoalSubmission)
        
    }
    const putComment = (value,ind) => {
        if(!assessmentSubmitted && !Utility.isEmpty(value)) {
            let newGoalSubmissions = deepClone(goalSubmissions);
            const newComment = {comment:value,createdBy: TenantService.get(TENANT.IAM_USER_ID)}
            newGoalSubmissions[ind]['comments'] = newGoalSubmissions[ind].comments ? [...newGoalSubmissions[ind].comments, newComment ] : [newComment];
            setGoalSubmissions(newGoalSubmissions);
        }
    }

    const getDisableCSS = (initial, isButton) => {
        let CSSClass = initial || "";

        if (assessmentSubmitted || !hasEnableAsessment) {
            CSSClass += isButton ? " disable-button" : " disable-section";
        }

        return CSSClass;
    }

    const getBannerMessageForEmployeeList = () => {
        let messageGroup = [
          {
            message: `Self assessment can be filled between ${moment(activeCycle['selfAssessmentStartDate'],DATE_FORMAT.IND).startOf('day').format(dateFormat)} to ${moment(activeCycle['selfAssessmentDueDate'],DATE_FORMAT.IND).endOf('day').format(dateFormat)}  `,
            isAction: false,
          },
        ];
        return messageGroup;
      }
    const renderSelfAssessmentReviews = () => {
        return (
            <Fragment>
                <div className="row">
                    <DKLabel text={t("PERFORMANCE")} className="fs-l fw-b" />
                    <div className="ml-auto d-flex">
                        <DKButton
                            title={t("CANCEL")}
                            className="bg-gray1 border-m"
                            onClick={() => {
                                RouteManager.navigateToHome();
                            }}
                        />
                        <DKButton
                            title={t("SAVE_AS_DRAFT")}
                            disable={!hasEnableAsessment}
                            className={getDisableCSS("bg-gray1 border-green text-app ml-m", true)}
                            onClick={() => {
                                saveAssessmentReview(true);
                            }}
                        />
                        <DKButton
                            title={t("SAVE_AND_SUBMIT")}
                            disable={!hasEnableAsessment}
                            className={getDisableCSS("bg-app text-white ml-m", true)}
                            onClick={() => {
                                showConfirmationMessage();
                            }}
                        />
                    </div>
                </div>
                {
                    !hasEnableAsessment && <div className="row pt-l">
                    <MessageInfo
                        message={getBannerMessageForEmployeeList()}
                        bannerClass=""
                        isClosable={false}
                    />
                </div>
                }
                <div className="mt-xxl">
                    <DKLabel text={t("COMPLETE_SELF_ASSISSMENT")} className="fs-m fw-b mb-xs" />
                    <DKLabel text={t("COMPLETE_SELF_ASSISSMENT_TEXT1")} className="fs-s fw-m text-gray mb-xs" />
                    <DKLabel text={t("COMPLETE_REVIEW_TEXT2")} className="fs-s fw-m text-gray" />
                    <div className="row mt-xl align-items-start">
                        <div style={{ flex: "0 0 40%", maxWidth: "40%" }}>
                            <div style={{ flex: "0 0 100%", maxWidth: "60%" }}>
                                <DKInput
                                    title={t("ASSESSMENT_PERIOD")}
                                    type={INPUT_TYPE.DROPDOWN}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    dropdownConfig={{
                                        data: assessmentPeriodOptions,
                                        renderer: (i, item) => item.label,
                                        onSelect: (i, value) => {
                                            setAssessmentPeriod(value.label);
                                            forceUpdate();
                                        },
                                    }}
                                    value={assessmentPeriod}
                                    onChange={() => { }}
                                />
                            </div>
                        </div>
                        <div style={{ flex: "0 0 30%", maxWidth: "30%" }}>
                            <DKLabel text={t("QUESTIONS")} className="text-gray" />
                            <DKLabel text={questionsCount} className="fs-m fw-b mt-l" />
                        </div>
                        <div style={{ flex: "0 0 30%", maxWidth: "30%" }}>
                            <DKLabel text={t("SELF_PROGRESS")} className="text-gray" />
                            <DKLabel text={`${selfAssessmentPercent}%`} className="fs-m fw-b m-v-s" />
                            <ProgressBar
                                completed={selfAssessmentPercent}
                                baseBgColor="#FDEDD4"
                                bgColor="#f6a625"
                                borderRadius="0"
                                isLabelVisible={false}
                                height="5px"
                                width={"60%"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row row-responsive">
                <div className={`bg-white border-radius-m p-v-xl mt-xxl  web-width-70 mb-auto ${goals && goals.length !== 0 ? "web-width-70":"web-width-100"}`}>
                    {selfAssessments.map((assessment, index) => renderAssessmentQuestions(assessment, index))}
                </div>
                {(goalSubmissions && goalSubmissions.length!==0) && <div className=" mt-m  web-width-30 mb-auto">
                    <DKLabel className="fw-m fs-m m-l" text="Current Goals:"/>
                    {goalSubmissions.map((goal, index) => renderGoal(goal, index, getCardParam()))}
                </div>}
                </div>
            </Fragment>
        );
    }
    const getCardParam = () =>{
        return {
            readOnly: assessmentSubmitted || !hasEnableAsessment,
            progressChange:progressChange,
            trackColor: {
                r: 253,
                g: 237,
                b: 212,
                a: 1,
            },
            fillColor: {
                r: 246,
                g: 166,
                b: 37,
                a: 1,
            },
            putComment:putComment
        }
    }

    const renderNoSelfAssessmentReview = () => {
        return (
            <Fragment>
                <div className="row">
                    <DKLabel text={t("PERFORMANCE")} className="fs-l fw-b" />
                </div>
                <div className="row justify-content-center">
                    <div className="column align-items-center position-absolute" style={{ top: "30%", pointerEvents: "none" }}>
                        <DKIcon
                            src={ic_no_data}
                            className="ic-l"
                            style={{ opacity: 0.2, marginTop: 70 }}
                        />
                        <DKLabel text={t("NO_REVIEW")} className="fw-m mt-m text-align-center" />
                    </div>
                </div>
            </Fragment>
        );
    }

    return (
        <div className="parent-width">
            {activeCycle !== -1 && <Fragment>
                {activeCycle ? renderSelfAssessmentReviews() : renderNoSelfAssessmentReview()}
            </Fragment>}
        </div>
    );
}

export default SelfAssessment;
